import angular from 'angular';
import moment from 'moment';

import templateUrl from './multi-play-commission-policy-list.component.html'

export const MultiPlayCommissionPolicyListComponent = {
    templateUrl,
    controller: MultiPlayCommissionPolicyListController,
    controllerAs: "vm",
    bindings: {
        division: "<"
    }
};

function MultiPlayCommissionPolicyListController($q, $timeout, $window, multiPlayCommissionPolicyService,
    multiPlayCommissionPolicyArchiveService, divisionService, productsService,
    productLinesService, utilityService) {
    'ngInject';

    const vm = this;
    vm.division;
    vm.pristineMultiPlayCommissionPolicies;
    vm.multiPlayCommissionPolicies = [];
    vm.products;
    vm.productLines;
    vm.divisions;
    vm.DivisionID;
    vm.today = moment().toDate();
    vm.loaded = false;
    vm.submitting = false;
    vm.showFilters = false;
    vm.filters = {};
    vm.filterMultiPlayCommissionPolicy = filterMultiPlayCommissionPolicy;
    vm.onCreateNewMultiPlayCommissionPolicy = onCreateNewMultiPlayCommissionPolicy;
    vm.onDeleteMultiPlayCommissionPolicy = onDeleteMultiPlayCommissionPolicy;
    vm.onSaveAll = onSaveAll;
    vm.onCancel = onCancel;
    $window.onbeforeunload = onBeforeUnload;
    vm.$onChanges = onChanges;

    return;
    function onChanges(changes) {
        if (changes.division && changes.division.currentValue) {
            vm.division = changes.division.currentValue;
            activate();
        }
    }
    function activate() {
        $q.when(utilityService.showLoading())
            .then(loadInitialData)
            .then(function () {
                vm.loaded = true;
                vm.pristineMultiPlayCommissionPolicies = angular.copy(vm.multiPlayCommissionPolicies);
            })
            .catch(function (ex) {
                $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(utilityService.hideLoading);
    }

    function loadInitialData() {

        const getProducts = productsService.retrieveProducts();
        const getProductLines = productLinesService.retrieveProductLines();
        const getDivisions = divisionService.retrieveDivisions();
        const getMultiPlayCommissionPolicies = multiPlayCommissionPolicyService
            .retrieveMultiPlayCommissionPolicies(vm.division.Id);

        return $q.all([getProducts, getProductLines, getMultiPlayCommissionPolicies, getDivisions])
            .then(function (v) {
                vm.divisions = v[3].filter(function (event) {
                    return vm.division.Id === event.Id
                });
                vm.products = v[0];
                vm.productLines = v[1];
                vm.pristineMultiPlayCommissionPolicies = fillMultiPlayCommissionPolicies(v[2],
                    vm.productLines, vm.divisions);
                vm.multiPlayCommissionPolicies = angular.copy(vm.pristineMultiPlayCommissionPolicies);
            });
    }

    function fillMultiPlayCommissionPolicies(multiPlayCommissionPolicies, productLines, divisions) {
        multiPlayCommissionPolicies.forEach(function (policy) {
            policy.Division = vm.divisions.filter(function (division) {
                return division.Id === policy.DivisionID;
            })[0];
            policy.Archives.sort(function (a, b) {
                if (a.ActiveOrderStart < b.ActiveOrderStart) {
                    return 1;
                } else if (a.ActiveOrderStart > b.ActiveOrderStart) {
                    return -1;
                } else {
                    if (a.ActiveInstalledStart < b.ActiveInstalledStart) {
                        return 1;
                    } else if (a.ActiveInstalledStart > b.ActiveInstalledStart) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            })[0];
            if (policy.Archives.length > 0) {
                policy.ActivePolicy = policy.Archives[0];
            }
            policy.Archives.forEach(function (archive) {
                archive.MultiPlayCommissionPolicyProductLines.forEach(function (lines) {
                    lines.ProductLine = productLines.filter(function (productLine) {
                        return productLine.ProductLineID === lines.ProductLineID;
                    })[0];
                });
            });
        });

        return multiPlayCommissionPolicies;
    }

    function filterMultiPlayCommissionPolicy(multiPlayCommissionPolicy) {
        return (!multiPlayCommissionPolicy.IsDeleted || !multiPlayCommissionPolicy.IsNew)
            && (!vm.filters.name || !multiPlayCommissionPolicy
                || multiPlayCommissionPolicy.Name.toLowerCase().indexOf(vm.filters.name.toLowerCase()) > -1);
    }

    function onCreateNewMultiPlayCommissionPolicy() {
        const newPolicy = {
            IsNew: true,
            IsDeleted: false,
            MultiPlayCommissionPolicyID: null,
            Archives: [],
            DivisionID: null,
            isOpen: true
        };

        vm.multiPlayCommissionPolicies.unshift(newPolicy);
        vm.editForm.$setDirty(true);

        //HACK: the edit forms don't regenerate properly after reloading. As a workaround,
        // make sure entire component is refreshed.
        vm.loaded = false;
        $timeout(function () {
            vm.loaded = true;
        });
    }

    function onDeleteMultiPlayCommissionPolicy(multiPlayCommissionPolicy) {
        if (multiPlayCommissionPolicy.Locked) {
            throw "Cannot delete a product commission policy because it contains locked archived.";
        }
        if (multiPlayCommissionPolicy.IsDeleted || !multiPlayCommissionPolicy.IsNew && !confirm("The policy will be deleted after you click Save.")) {
            // Clicking delete a second time toggles IsDeleted back off.
            multiPlayCommissionPolicy.IsDeleted = false;
            return;
        }
        vm.loaded = false;
        $timeout(function () {
            const index = vm.multiPlayCommissionPolicies.indexOf(multiPlayCommissionPolicy);
            if (index > -1) {
                vm.multiPlayCommissionPolicies.splice(index, 1);
            }
            vm.loaded = true;
        })
    }

    function mapToDTO(policy) {
        return {
            Id: policy.Id,
            Count: policy.Count,
            Name: policy.Name,
            DivisionID: policy.DivisionID,
            Archives: policy.Archives.map(p => ({
                Id: p.Id,
                ActiveInstalledStart: p.ActiveInstalledStart ?
                    moment(p.ActiveInstalledStart).format("YYYY-MM-DD") : null,
                ActiveInstalledEnd: p.ActiveInstalledEnd ? moment(p.ActiveInstalledEnd).format("YYYY-MM-DD") : null,
                ActiveOrderStart: p.ActiveOrderStart ? moment(p.ActiveOrderStart).format("YYYY-MM-DD") : null,
                ActiveOrderEnd: p.ActiveOrderEnd ? moment(p.ActiveOrderEnd).format("YYYY-MM-DD") : null,
                ProductLines: p.MultiPlayCommissionPolicyProductLines.map(q => ({
                    Id: q.Id,
                    ProductLineID: q.ProductLineID,
                    Amount: q.Amount
                }))
            })),
        }
    }

    function onSaveAll() {
        if (!vm.editForm.$valid) {
            alert("Not valid.");
        }
        const requests = [];
        vm.submitting = true;
        utilityService.showLoading();
        vm.loaded = false;
        const filteredPoliciesRequest = vm.multiPlayCommissionPolicies.filter(function (event) {
            return !event.IsNew && event.IsDeleted || event.editForm && event.editForm.$dirty;
        }).map(function (policy) {
            let saveRequest;
            if (policy.IsDeleted) {
                saveRequest = multiPlayCommissionPolicyService.deleteMultiPlayCommissionPolicy(policy.Id);
            } else if (policy.IsNew) {
                saveRequest = multiPlayCommissionPolicyService.createMultiPlayCommissionPolicy(mapToDTO(policy));
            } else {
                saveRequest = multiPlayCommissionPolicyService.updateMultiPlayCommissionPolicy(policy.Id,
                    mapToDTO(policy));
            }
            return saveRequest.catch(function (ex) {
                if (ex.data && ex.data.ModelState) {
                    policy.errorModelState = ex.data.ModelState;
                }
                throw ex;
            });
        });
        requests.push(...filteredPoliciesRequest);

        const saved = $q.all(requests);

        saved.catch(function (ex) {
            vm.loaded = true;
            alert("Saving failed: " + utilityService.getExceptionMessage(ex));
        });

        saved
            .then(function () {
                return multiPlayCommissionPolicyService.retrieveMultiPlayCommissionPolicies(vm.division.Id);
            })
            .then(function (multiPlayCommissionPolicies) {
                return fillMultiPlayCommissionPolicies(multiPlayCommissionPolicies, vm.productLines);
            })
            .then(function (multiPlayCommissionPolicies) {
                vm.multiPlayCommissionPolicies = [];
                vm.pristineMultiPlayCommissionPolicies = multiPlayCommissionPolicies;
                vm.multiPlayCommissionPolicies = angular.copy(vm.pristineMultiPlayCommissionPolicies);
                return vm.pristineMultiPlayCommissionPolicies;
            })
            .then(function () {
                // HACK: Force the whole component to regenerate. There is an issue with the edit forms that
                // makes them null after reloading the pristine policies.
                return $timeout(function () {
                    vm.loaded = true;
                })
            })
            .catch(function (ex) {
                console.error(ex);
            })
            .then(function () {
                vm.submitting = false;
                utilityService.hideLoading()
            });
    }

    function onCancel() {
        vm.submitting = false;
        vm.loaded = false;
        vm.multiPlayCommissionPolicies = angular.copy(vm.pristineMultiPlayCommissionPolicies);
        vm.editForm.$setPristine(true);
        $timeout(function () {
            //HACK: the edit forms don't regenerate properly after reloading. As a workaround,
            // make sure entire component is refreshed.
            vm.loaded = true;
        });
    }

    function onBeforeUnload() {
        if (vm.editForm && vm.editForm.$dirty) {
            return "You have unchanged changes that will be lost if you leave the page.";
        }
    }
}
